export default __webpack_public_path__ + "static/media/Mark-6-Blueprints-00.373c5928.jpg";